/**
 * Phase 72 (currency-aware budgets, Plan 04) — shared provisional/locked
 * pill color tokens.
 *
 * Extracted verbatim from `ToBeInvoicedCard.tsx` (Phase 70-05) so that both
 * the "Billable entries" pill on that card and the Money Budget tracker's
 * provisional/locked marker (`ProjectStatisticsSection.tsx`) render from a
 * single source — no color drift between the two surfaces (RESEARCH
 * Pattern 3).
 *
 * provisional = open period, CZK equivalent is a live read-time recompute.
 * locked = period closed, CZK equivalent is an immutable snapshot.
 */
export const BILLING_LOCK_COLORS = {
  provisional: { bg: '#FEF3C7', fg: '#92400E', dot: '#F59E0B' },
  locked: { bg: '#E5E7EB', fg: '#374151', dot: '#9CA3AF' },
} as const;
